import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Plus, CheckCircle, Circle } from "@phosphor-icons/react";

/**
 * Milestones tab — add / toggle / open. Behavior-preserving extraction.
 */
export default function EngagementMilestonesTab({
  engagement: e, msOpen, setMsOpen, ms, setMs,
  onAddMilestone, onToggleMilestone, onOpenMilestone,
}) {
  return (
    <div className="border border-border bg-card">
      <div className="flex items-center justify-between border-b border-border px-5 py-3">
        <h3 className="font-display font-bold text-sm">Milestones</h3>
        <Dialog open={msOpen} onOpenChange={setMsOpen}>
          <DialogTrigger asChild>
            <Button size="sm" className="rounded-none bg-primary text-primary-foreground" data-testid="add-milestone-btn">
              <Plus size={12} className="mr-1" />Add
            </Button>
          </DialogTrigger>
          <DialogContent className="rounded-none">
            <DialogHeader><DialogTitle>New milestone</DialogTitle></DialogHeader>
            <Input placeholder="Title" value={ms.title} onChange={(v) => setMs({ ...ms, title: v.target.value })} className="rounded-none bg-secondary/40" />
            <Input type="date" value={ms.due_date} onChange={(v) => setMs({ ...ms, due_date: v.target.value })} className="rounded-none bg-secondary/40" />
            <DialogFooter><Button onClick={onAddMilestone} className="rounded-none bg-primary text-primary-foreground">Add</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      <div className="divide-y divide-border">
        {(e.milestones || []).length === 0 && <div className="px-5 py-8 text-xs text-muted-foreground text-center">No milestones yet.</div>}
        {(e.milestones || []).map((m, i) => (
          <div key={i} className="px-5 py-3 flex items-center gap-3 hover:bg-secondary/30 transition-colors" data-testid={`engagement-milestone-row-${i}`}>
            <button onClick={() => onToggleMilestone(i)} className="text-primary hover:opacity-80 shrink-0" aria-label="Toggle complete" data-testid={`milestone-toggle-${i}`}>
              {m.status === "done" ? <CheckCircle size={18} weight="fill" /> : <Circle size={18} />}
            </button>
            <button
              onClick={() => onOpenMilestone(m, i)}
              data-testid={`milestone-open-${i}`}
              className={`flex-1 text-left ${m.status === "done" ? "line-through text-muted-foreground" : ""}`}
            >
              <div className="text-sm font-medium">{m.title}</div>
              {m.due_date && <div className="text-[0.625rem] font-mono uppercase text-muted-foreground tracking-widest">Due {m.due_date}</div>}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
